import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import { CommandStackAction } from '@ispm/shared/bpmn-io/commandstack-action';
import { UserInitiatedAction, UserInitiatedActionsActionTypes } from '../actions/user-initiated-actions.actions';
import {cloneDeep} from "lodash";

export function userInitiatedActions(state = initialState.userInitiatedActions, action: UserInitiatedAction): CommandStackAction[] {
    switch (action.type) {
      case UserInitiatedActionsActionTypes.ADD_ACTION: {

        return [...state, {command:action.payload.command, context: cloneDeep(action.payload.context), id:action.payload.id}];
      }
      case UserInitiatedActionsActionTypes.CLEAR_ACTIONS: {
        return new Array<CommandStackAction>();
      }
      case UserInitiatedActionsActionTypes.REMOVE_ACTION: {
        return cloneDeep(state.slice(0, state.length - 1));
      }
      default: {
          return state;
      }
    }
  }
  